"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSubmittedOrder = exports.setSubmittedOrder = exports.clearPrintBatch = exports.createPrintBatch = exports.clearCustomerInformation = exports.setCustomerInformation = exports.clearSelectedStore = exports.setSelectedStore = void 0;
const immer_1 = require("immer");
const typedLocalStorage_1 = require("../../../lib/browser/typedLocalStorage");
const client_1 = require("@apollo/client");
const SET_SELECTED_STORE = "checkout.set_selected_store";
const SET_CUSTOMER_INFORMATION = "checkout.set_customer_information";
const CREATE_PRINT_BATCH_STARTED = "checkout.create_print_batch_started";
const CREATE_PRINT_BATCH_COMPLETED = "checkout.create_print_batch_completed";
const CREATE_PRINT_BATCH_ERROR = "checkout.create_print_batch_error";
const CLEAR_PRINT_BATCH = "checkout.clear_print_batch";
const SET_SUBMITTED_ORDER = "checkout.set_submitted_order";
function setSelectedStore(selectedStore, zip) {
    return {
        type: SET_SELECTED_STORE,
        selectedStore,
        zip,
    };
}
exports.setSelectedStore = setSelectedStore;
function clearSelectedStore() {
    return {
        type: SET_SELECTED_STORE,
        selectedStore: null,
    };
}
exports.clearSelectedStore = clearSelectedStore;
function setCustomerInformation(customerInformation) {
    return {
        type: SET_CUSTOMER_INFORMATION,
        customerInformation,
    };
}
exports.setCustomerInformation = setCustomerInformation;
function clearCustomerInformation() {
    return {
        type: SET_CUSTOMER_INFORMATION,
        customerInformation: null,
    };
}
exports.clearCustomerInformation = clearCustomerInformation;
const CREATE_PRINTS = (0, client_1.gql) `
  mutation createRectangularPrints($input: CreateRectangularPrintsRequest) {
    createRectangularPrints(input: $input) {
      prints {
        key
        url
      }
    }
  }
`;
function createPrintBatch(client, fileId, printOptions, printLayouts) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const input = {
            fileId,
            format: "jpeg",
            dpi: 300,
            printOptions,
            printLayouts,
        };
        dispatch(createPrintBatchStarted(input));
        try {
            const result = yield client.mutate({
                mutation: CREATE_PRINTS,
                variables: {
                    input,
                },
                fetchPolicy: "network-only",
            });
            const printResponse = result.data
                .createRectangularPrints;
            dispatch(createPrintBatchCompleted(printLayouts, printResponse.prints));
        }
        catch (e) {
            dispatch(createPrintBatchError("Error generating prints."));
        }
        // TODO - Handle Errors
    });
}
exports.createPrintBatch = createPrintBatch;
function createPrintBatchStarted(input) {
    return {
        type: CREATE_PRINT_BATCH_STARTED,
        input,
    };
}
function createPrintBatchCompleted(printLayouts, printFiles) {
    return {
        type: CREATE_PRINT_BATCH_COMPLETED,
        printLayouts,
        printFiles,
    };
}
function createPrintBatchError(error) {
    return {
        type: CREATE_PRINT_BATCH_ERROR,
        error,
    };
}
function clearPrintBatch() {
    return {
        type: CLEAR_PRINT_BATCH,
    };
}
exports.clearPrintBatch = clearPrintBatch;
function setSubmittedOrder(submittedOrder) {
    return { type: SET_SUBMITTED_ORDER, submittedOrder };
}
exports.setSubmittedOrder = setSubmittedOrder;
function clearSubmittedOrder() {
    return { type: SET_SUBMITTED_ORDER, submittedOrder: null };
}
exports.clearSubmittedOrder = clearSubmittedOrder;
const localItem = (0, typedLocalStorage_1.LocalItem)("mapmaker.wgcheckout");
exports.default = (0, immer_1.produce)((draft, action) => {
    if (draft === undefined) {
        return Object.assign(Object.assign({}, (localItem.get() || {})), { printBatch: {
                loading: false,
            }, submittedOrder: null });
    }
    function saveLocalState() {
        localItem.put(Object.assign(Object.assign({}, draft), { 
            // Never store the print batch or submitted order. Would cause very confusing states.
            printBatch: undefined, submittedOrder: undefined }));
    }
    switch (action.type) {
        case SET_SELECTED_STORE:
            draft.selectedStore = action.selectedStore;
            draft.zip = action.zip;
            saveLocalState();
            break;
        case SET_CUSTOMER_INFORMATION:
            draft.customerInformation = action.customerInformation;
            saveLocalState();
            break;
        case CREATE_PRINT_BATCH_STARTED:
            draft.printBatch = {
                loading: true,
                input: action.input,
            };
            break;
        case CREATE_PRINT_BATCH_COMPLETED:
            draft.printBatch = {
                loading: false,
                input: draft.printBatch.input,
                printFiles: action.printFiles,
                printLayouts: action.printLayouts,
            };
            break;
        case CREATE_PRINT_BATCH_ERROR:
            draft.printBatch = {
                loading: false,
                error: action.error,
                input: draft.printBatch.input,
            };
            break;
        case CLEAR_PRINT_BATCH:
            draft.printBatch = {
                loading: false,
            };
            break;
        case SET_SUBMITTED_ORDER:
            draft.submittedOrder = action.submittedOrder;
            break;
        default:
            break;
    }
});
//# sourceMappingURL=data:application/json;base64,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